import { render, staticRenderFns } from "./ListViewTemplateNewOld.vue?vue&type=template&id=d84fac7a&scoped=true"
import script from "./ListViewTemplateNewOld.vue?vue&type=script&lang=js"
export * from "./ListViewTemplateNewOld.vue?vue&type=script&lang=js"
import style0 from "./ListViewTemplateNewOld.vue?vue&type=style&index=0&id=d84fac7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d84fac7a",
  null
  
)

export default component.exports